export const QUESTIONNAIRES_RETRIEVE_SUCCESS =
  'QUESTIONNAIRES_RETRIEVE_SUCCESS';
export const QUESTIONNAIRES_GET = 'QUESTIONNAIRES_GET';
export const QUESTIONNAIRES_SUBMIT = 'QUESTIONNAIRES_SUBMIT';
export const QUESTIONNAIRES_UPDATE_PROGRESS = 'QUESTIONNAIRES_UPDATE_PROGRESS';
export const QUESTIONNAIRES_CLEAR_PROGRESS = 'QUESTIONNAIRES_CLEAR_PROGRESS';
